import { maxMobileWidth } from "@/constants/share";
import WebHome from "./Web";
import MobileHome from "./Mobile";
import { useEffect } from "react";

export default function Home() {
  useEffect(() => {
    document.title = 'AI会记';
  }, [])
  
  return (
    <>
      {document.documentElement.clientWidth <= maxMobileWidth && !window.LinkService ? (
        <MobileHome />
      ) : (
        <WebHome />
      )}
    </>
  );
}
